(function ($) {
  if (!$) return;

$(document).ready(function () {
  var $accordionList = $(".product-info-accordion-list > li");
  var $accordionAnswer = $(".answer");

  $accordionAnswer.hide();

  $accordionList.click(function (e) {
    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active").find(".answer").slideUp();
    } else {
      $accordionList.removeClass("active").find(".answer").slideUp();
      $this.addClass("active").find(".answer").slideDown();
    }
    e.stopPropagation();
  });

  $accordionAnswer.find("a").click(function (e) {
    e.stopPropagation();
  });

  document.querySelectorAll(".toolbar-icon").forEach((item) => {
    item.addEventListener("click", function () {
      const col = this.getAttribute("data-col");

      // Select the main collection product grid container
      const gridContainer = document.querySelector(
        "#main-collection-product-grid"
      );

      if (gridContainer) {
        // Remove any existing column class (e.g., column-2, column-3, column-4)
        gridContainer.classList.forEach((className) => {
          if (className.startsWith("column-")) {
            gridContainer.classList.remove(className); // Remove existing column class
          }
        });

        // Add the new column class based on the selected column
        gridContainer.classList.add(`column-${col}`);
      }

      // Remove active class from all toolbar icons
      document
        .querySelectorAll(".toolbar-icon")
        .forEach((icon) => icon.classList.remove("active"));

      // Add active class to the clicked icon
      this.classList.add("active");
    });
  });

  // Filtering functionality (no changes made here, keeping it as is)
  const filterHeadings = document.querySelectorAll(
    ".storefront-filter__heading"
  );
  const closeButton = document.querySelector(".close-all-dropdowns");
  const facetsWrapper = document.querySelector(".facets__wrapper");
  const clearButton = document.querySelector(".clear-all-filters");

  // Bail early if the filter UI isn't on this page (homepage, PDPs, cart,
  // article pages, etc.). These elements only render on collection/search
  // pages. Without this guard, closeButton.addEventListener at line ~78,
  // facetsWrapper.classList at line ~98, clearButton.addEventListener at
  // line ~111, and CollectionFiltersForm.submit() at line ~118 all throw
  // null/undefined errors on every non-collection page load.
  if (!filterHeadings.length || !closeButton || !facetsWrapper || !clearButton) {
    return;
  }

  filterHeadings.forEach((heading) => {
    heading.addEventListener("click", function (event) {
      event.stopPropagation();
      const display = this.querySelector(".storefront-filter__display");
      // Null guard: a filter heading may not contain a .storefront-filter__display
      // child on every page/markup variant. Without this, `display.style` on the
      // next line throws — surfaced by Clarity as "null is not an object
      // (evaluating 'display.style')" (Safari) / "Cannot read properties of null
      // (reading 'style')" (Chrome), ~278/wk combined. Bail silently instead.
      if (!display) return;
      const isOpen = display.style.opacity === "1";
      closeAllDropdowns();

      if (!isOpen) {
        display.style.opacity = "1";
        display.style.visibility = "visible";
        display.style.transform = "translateY(0)";
        display.style.transitionDelay = "0s";
        closeButton.style.display = "block";
        facetsWrapper.classList.add("facets__wrapper-active");
      }
    });
  });

  closeButton.addEventListener("click", function (event) {
    event.stopPropagation();
    closeAllDropdowns();
    this.style.display = "none";
  });

  document.addEventListener("click", function () {
    closeAllDropdowns();
    closeButton.style.display = "none";
  });

  function closeAllDropdowns() {
    document
      .querySelectorAll(".storefront-filter__display")
      .forEach((display) => {
        display.style.opacity = "0";
        display.style.visibility = "hidden";
        display.style.transform = "translateY(-10px)";
        display.style.transitionDelay = "0.05s";
      });
    facetsWrapper.classList.remove("facets__wrapper-active");
  }

  const filterCheckboxes = document.querySelectorAll(
    '.storefront-filter__item input[type="checkbox"]'
  );
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      updateFilterCounts();
    });
  });

  clearButton.addEventListener("click", function () {
    document
      .querySelectorAll('.storefront-filter__item input[type="checkbox"]')
      .forEach((checkbox) => {
        checkbox.checked = false;
      });
    updateFilterCounts();
    var collectionFiltersForm = document.getElementById("CollectionFiltersForm");
    if (collectionFiltersForm) {
      collectionFiltersForm.submit(); // Submit the form to reset the filters
    }
  });

  function updateFilterCounts() {
    filterHeadings.forEach((heading) => {
      const checkboxes = heading.querySelectorAll(
        'input[type="checkbox"]:checked'
      );
      const countSpan = heading.querySelector(".filter-count");
      if (countSpan) {
        const count = checkboxes.length;
        countSpan.textContent = count;
        countSpan.style.display = count > 0 ? "inline" : "none";
      }
    });
    updateClearButtonVisibility();
  }

  function updateClearButtonVisibility() {
    const anyChecked = Array.from(
      document.querySelectorAll(
        '.storefront-filter__item input[type="checkbox"]'
      )
    ).some((checkbox) => checkbox.checked);

    clearButton.style.display = anyChecked ? "block" : "none";
  }

  // Initialize filter counts on page load
  updateFilterCounts();
});

document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll(".menu-lv-item.dropdown");
  const headerBottom = document.querySelector(
    ".header-02 .wrapper-header-bottom"
  );

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("mouseenter", () => {
      headerBottom.classList.add("active");
    });
    dropdown.addEventListener("mouseleave", () => {
      headerBottom.classList.remove("active");
    });
  });
});

//stick filter top

document.addEventListener("DOMContentLoaded", function () {
  // Bail early if #splide isn't on this page. This block is a PDP-only
  // feature (variant-filtered Splide carousel) and depends on:
  //   - #splide element
  //   - .product-form__input radios with data-option attributes
  // Without this guard, "new Splide('#splide', ...)" throws
  // "[splide] null is invalid" on every non-PDP page (homepage, collections,
  // cart, search, etc.).
  if (!document.querySelector("#splide")) {
    return;
  }

  var splide = new Splide("#splide", {
    type: "loop",
    perPage: 3,
    arrows: false,
    pagination: false,
    autoScroll: {
      speed: 1,
    },
    breakpoints: {
      1200: {
        perPage: 2,
      },
      600: {
        perPage: 1,
        type: "slide",
      },
    },
  }).mount(window.splide.Extensions);

  var productFormOption1 = document.querySelectorAll(
    '.product-form__input[data-option-index="1"] .product-form__radio'
  );

  function filterSlides(variant) {
    splide.destroy(); // Destroy the current instance to reinitialize it
    document.querySelectorAll(".splide__slide").forEach(function (slide) {
      if (slide.getAttribute("data-variant") === variant) {
        slide.style.display = "block";
      } else {
        slide.style.display = "none";
      }
    });
    splide = new Splide("#splide", {
      type: window.innerWidth <= 600 ? "slide" : "loop",
      perPage: 3,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        1200: {
          perPage: 2,
        },
        600: {
          perPage: 1,
          type: "slide",
          arrows: true,
        },
      },
    }).mount(window.splide.Extensions);
  }

  // Initial filter based on the default selected variant
  var selectedColor = document
    .querySelector(
      '.product-form__input[data-option-index="1"] .product-form__radio:checked'
    )
    .getAttribute("data-option");
  filterSlides(selectedColor);

  // Update the slides when a swatch is clicked
  productFormOption1.forEach(function (radio) {
    radio.addEventListener("change", function () {
      var selectedColor = this.getAttribute("data-option");
      filterSlides(selectedColor);
    });
  });
});

$(document).ready(function() {
  $('.productView-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    autoplay: false,
    adaptiveHeight: false,
    speed: 400,
    cssEase: 'ease'
  });
});


$(document).ready(function () {
  $(".paired-products1").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          dots: true,
          autoplay: true,
        },
      },
    ],
  });
});
$(document).ready(function () {
  $(".homepage--guides1").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // Adjust the autoplay speed if needed
    speed: 8000, // Adjust the speed for smoother pause on hover
    cssEase: "linear", // This ensures smooth continuous scroll
    arrows: false,
    dots: false,
    infinite: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          draggable: true,
        },
      },
    ],
  });
});
})(window.jQuery || window.$);

// REMOVED: jQuery.waypoint floating-text-on-scroll feature.
// Used .js-section elements with data-text attributes to update a
// .js-floating-text span as the user scrolled. Confirmed dead:
//   - The jQuery Waypoints library was never loaded by the theme,
//     so section.waypoint() always threw TypeError.
//   - Grep across the entire theme found NO templates/snippets/sections
//     rendering .js-section, .js-floating-text, or data-text attributes.
// Feature abandoned. Removing the JS that calls it.

//scroll To
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[href^="#"]');

  for (const link of links) {
    link.addEventListener("click", function (event) {
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      // Exclude specific links from triggering the smooth scroll
      if (targetId === "login" || targetId === "recover") {
        event.preventDefault();
        // Toggle the visibility of the forms without scrolling
        if (targetId === "recover") {
          document.getElementById("recover").style.display = "block";
          document.getElementById("login").style.display = "none";
        } else if (targetId === "login") {
          document.getElementById("login").style.display = "block";
          document.getElementById("recover").style.display = "none";
        }
        return;
      }

      if (targetElement) {
        event.preventDefault();
        smoothScroll(targetElement);
      }
    });
  }

  function smoothScroll(target) {
    const targetPosition = target.getBoundingClientRect().top;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - 0; // Adjust for any fixed headers
    const duration = 1000;
    let start = null;

    window.requestAnimationFrame(step);

    function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const easing = easeInOutQuad(progress / duration);
      window.scrollTo(0, startPosition + distance * easing);

      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
});

// REMOVED: .tech-pack-hemp-rail__carousel owlCarousel init.
// The Owl Carousel jQuery plugin was never loaded by the theme so the
// init always threw "$(...).owlCarousel is not a function". Per product
// decision the entire hemp tech-pack carousel feature is being retired —
// the {% render 'hemp-tech-pack' %} call has also been removed from
// snippets/fabric-info.liquid. The hemp-tech-pack.liquid snippet file
// itself is left on disk inert (Shopify only loads what's referenced).

// PDP "+ More details" link (CRO live-crawl audit finding #8).
// The short product description is a plain <p> users click expecting it to
// expand; the detail accordions sit ~1000px below the Add to Bag button.
// The link (.pdp-more-details, in snippets/pro-desc.liquid) opens the first
// accordion item (Maker's Notes) by re-using the existing
// .product-info-accordion-list > li click handler, then scrolls to it.
(function ($) {
  if (!$) return;

  $(document).ready(function () {
    var $moreDetails = $(".pdp-more-details");
    if (!$moreDetails.length) return;
    var $infoAccordion = $(".product-info-accordion-list").first();
    // No accordion on this page/template - hide the link so it is never a
    // dead control (the very problem this fix removes).
    if (!$infoAccordion.length) {
      $moreDetails.hide();
      return;
    }
    $moreDetails.on("click", function (e) {
      e.preventDefault();
      var $firstItem = $infoAccordion.children("li").first();
      // Only trigger when closed - triggering an open item collapses it.
      if ($firstItem.length && !$firstItem.hasClass("active")) {
        $firstItem.trigger("click");
      }
      // Native scrollIntoView respects the theme's html{scroll-behavior:smooth};
      // jQuery .animate({scrollTop}) fights it and can stutter.
      if ($infoAccordion[0]) {
        $infoAccordion[0].scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
})(window.jQuery || window.$);
